import { h, FunctionalComponent } from "preact";
import { useState } from "preact/hooks";

interface GridSwitchProps {
  onSwitch: (columns: number) => void;
  switcherClass: string;
}

const GridSwitch: FunctionalComponent<GridSwitchProps> = ({
  onSwitch,
  switcherClass,
}) => {
  const [selectedColumns, setSelectedColumns] = useState<number>(4); // Default to 4 columns

  const handleSwitch = (columns: number) => {
    setSelectedColumns(columns);
    onSwitch(columns);
  };

  return (
    <div className={`collection__grid-switcher ${switcherClass}`}>
      <button
        dangerouslySetInnerHTML={{
          __html: window.themeVars.icons.singleColumn,
        }}
        onClick={() => handleSwitch(4)}
        className={`collection__grid-switcher__button ${selectedColumns === 4 ? "selected" : ""}`}
        aria-label={window.themeVars.strings.collection.singleColumn}
        value={window.themeVars.strings.collection.singleColumn}
      ></button>
      <button
        dangerouslySetInnerHTML={{
          __html: window.themeVars.icons.fourColumns,
        }}
        onClick={() => handleSwitch(1)}
        className={`collection__grid-switcher__button ${selectedColumns === 1 ? "selected" : ""}`}
        aria-label={window.themeVars.strings.collection.fourColumns}
        value={window.themeVars.strings.collection.fourColumns}
      ></button>
    </div>
  );
};

export default GridSwitch;
